function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconCalendar = function IconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    width: "100",
    height: "97",
    viewBox: "0 0 100 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.63086 31.459H97.3677",
    stroke: "currentColor",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5791 7.86523H34.0527",
    stroke: "currentColor",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2624 7.86523H9.0256C5.49928 7.86523 2.63086 10.7228 2.63086 14.2358V87.982C2.63086 91.495 5.49928 94.3525 9.0256 94.3525H90.9467C94.473 94.3525 97.3414 91.495 97.3414 87.982V14.2358C97.3414 10.7228 94.473 7.86523 90.9467 7.86523H85.3677",
    stroke: "currentColor",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1582 0V15.7297",
    stroke: "currentColor",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4746 0V15.7297",
    stroke: "currentColor",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9473 51.1219L49.842 47.1895V70.784",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9473 70.7842H57.7367",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinejoin: "round"
  }));
};